import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import * as yup from 'yup';

const useStatusFormValidationSchema = () => {
	const { t } = useTranslation();

	return useMemo(
		() =>
			yup.object({
				externalId: yup.number().integer(t('ID must be an integer')).typeError(t('ID must be a number')),
			}),
		[t],
	);
};

export default useStatusFormValidationSchema;
